<template>
    <div class="container-register-header">
        <button class="btn-header-back" @click="backEvent()"></button>
        <div class="title-register-header">
            {{ title }}
        </div>
        <div class="btn-header-action">
            <slot name="header_btn">

            </slot>
        </div>
    </div>
</template>


<script>
export default {
    name: "RegisterHeader",
    mixins: [],
    components: {
        //
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        BackEvent: {type: null, default: false},
        title: {type: String, default: ''},

    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeUnmount() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        backEvent() {
            if (this.BackEvent) {
                this.BackEvent();
                return false;
            }
            this.$router.back();
        },

    },
    watch: {},
}
</script>

<style scoped></style>
